import { render } from "./ShareHolderMonthlyDeposit.vue?vue&type=template&id=0fc2a26a"
import script from "./ShareHolderMonthlyDeposit.vue?vue&type=script&lang=js"
export * from "./ShareHolderMonthlyDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__